export const settingsApp = {
  "AccountSettings.MediaRequestsSettings.SaveButton":
    "mediaRequest-save-button",
  "AccountSettings.JobsFeed.EditButton": "jobsFeed-edit-button",
  "AccountSettings.JobsFeed.SaveButton": "jobsFeed-Save-button",
};
